import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["menu", "icon"];

  connect() {
    this.menuOpen = false;
  }

  toggleMenu() {
    this.menuOpen = !this.menuOpen;
    this.menuTarget.classList.toggle("hidden", !this.menuOpen);
    this.iconTarget.classList.toggle("active", this.menuOpen);
  }
}